import axios from 'axios'

export const logout = async () => {
  return await axios.post(
    `${process.env.REACT_APP_API_URL}/logout`,
    {},
    {
      withCredentials: true,
    },
  )
}
